import React, { useState, useEffect, useRef, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
//Redux actions import
import PhoneVerificationActions from "../../../Redux/transition/phone-verification/phone-verification.reducer";
import SubscriberActions from "../../../Redux/transition/subscriber/subscriber.reducer";
import SelfSignupActions from "../../../Redux/transition/self-signup/self-signup.reducer";
import BusinessActions from "../../../Redux/actions/business-actions"
//primereact imports
import { useTranslation, Trans } from "react-i18next";
import { Button } from "primereact/button";
import { Dialog } from 'primereact/dialog';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useFormik } from "formik";
import { Toast } from 'primereact/toast';
//Other imports
import moment from "moment";
import { amountDisplayPerPolicy, formatBillingPeriodText, policyDisplay } from "../../../Components/CleanInputs";
import "../../../Styles/components/sti.css"
import "../../../Styles/pages/inviteSubscriber.scss"
import Loading from "../../../Components/Loading";
import "../../../Styles/pages/invitation.scss";
import OnboardingNotification from "../../../Components/OnboardingNotification";
import SigningPendingNotice from "../../../Components/SigningPendingNotice";
import GoLiveOutstandingDialog from "../../../Components/GoLiveOutstandingDialog";
import DocumentActions from "../../../Redux/transition/document-upload/document-upload.reducer";
import { removePlusFromNum } from "../../../Components/CleanInputs";
import { FormatCurrency, useCurrencyConstants } from '../../../Components/CurrencyFormatter';
import AutoBillingBadge from "../../../Components/AutoBillingBadge";
//  These might be needed later 
// import { SegmentDropdown } from "./InviteComponents/SegmentDropdown";
// import { TagsMultiselect } from "./InviteComponents/TagsMultiselect";
import { PlanTreeSelect } from "./InviteComponents/PlanTreeSelect";
import { PhoneNumberInputText } from "./InviteComponents/PhoneNumberInputText";
import { StartDateCalender } from "./InviteComponents/StartDateCalender";
import { AmountInputNumber } from "./InviteComponents/AmountInputNumber";
import { DeductionsInput } from "./InviteComponents/DeductionsInput";
import { GlobalSearch } from "../../../Components/GlobalSearch";
import { AmbiguousCustomerDialog } from "./InviteComponents/AmbiguousCustomerDialog";
import { normalizePhoneNumber, buildMsisdn, isValidInternationalPhoneNumber, toLocalPhoneNumber, getInvalidMobilePrefix } from "../../../utils/phoneUtils";
import { hasCurrentProviderCredentials } from "../../../utils/pspOnboarding";

const EMPTY_CUSTOMER_SEARCH_STATE = {
	filteredCustomers: [],
	exactFilteredBusinessCustomers: [],
	selectedCustomerId: null,
	isCustomerSelected: false,
	query: "",
};

const AMBIGUOUS_BUSINESS_CUSTOMER = "AMBIGUOUS_BUSINESS_CUSTOMER";

const toInvitationBusinessCustomer = (customer) => {
	if (!customer?.id) return null;
	return { id: customer.id };
};

const toPlainArray = (value) => {
	if (!value) return [];
	if (typeof value.asMutable === "function") return value.asMutable({ deep: true });
	return Array.isArray(value) ? value : [];
};

const getAmbiguousBusinessCustomerCandidates = (error) => {
	if (!error || error.code !== AMBIGUOUS_BUSINESS_CUSTOMER) return [];
	return toPlainArray(error.candidates).filter((candidate) => candidate?.id);
};

const InviteSubscriber = (props) => {
	//redux state and dispatch to props + props from parent component
	const { onHide, initialTier, phoneNo, toggleVisible, header, callbackFunctions,
		fromSubscriberImport, csvFileData, sendBulkInvite, makingBulkInvite, bulkInviteSuccess, fetchAllImportedCustomers,
		businessCustomer, selectedSubscriberSegment } = props

	const defMembership = useSelector((state) => state.defMembership.defMembership)
	const business = useSelector((state) => state.businesses.business)
	const planGroupsGraphedActive = useSelector((state) => state.planGroups.planGroupsGraphedActive)
	const fetchingExclusivity = useSelector((state) => state.subscribers.fetchingExclusivity)
	const exclusivity = useSelector((state) => state.subscribers.exclusivity)
	const errorExclusivity = useSelector((state) => state.subscribers.errorExclusivity)
	const generating = useSelector((state) => state.phoneVerifications.generating)
	const phoneVerification = useSelector((state) => state.phoneVerifications.phoneVerification)
	const error = useSelector((state) => state.phoneVerifications.errorGenerating)
	const paymentCredentials = useSelector((state) => state.payswitch.paymentCredentials);
	const credentials = useSelector((state) => state.payswitch.credentials);
	const fetchingVerifStatus = useSelector((state) => state.documents.fetchingVerifStatus);
	const verificationStatus = useSelector((state) => state.documents.verifStatus);
	const signingPending = useSelector((state) => state.documents.signingPending);
	const fetchingMerchantAgreements = useSelector((state) => state.documents.fetchingMerchantAgreements);

	const dispatch = useDispatch()
	const checkExclusivity = useCallback((newPlanId, msisdn) => dispatch(SubscriberActions.subscriberExclusivityRequest(newPlanId, msisdn)), [dispatch])
	const getSelfSignups = useCallback((businessId, options) => dispatch(SelfSignupActions.selfSignupAllRequest(businessId, options)), [dispatch])
	const generateCode = useCallback((generationRequest) => dispatch(PhoneVerificationActions.generateCodeRequest(generationRequest)), [dispatch])
	const getBusiness = useCallback((businessId) => { dispatch(BusinessActions.businessRequest(businessId)) }, [dispatch])
	const getMerchantAgreements = useCallback((businessId, provider) => dispatch(DocumentActions.merchantAgreementsRequest(businessId, provider)), [dispatch])

	const { t } = useTranslation("common");
	const toast = useRef("");
	const toastConfirm = useRef("");
	const [sending, setSending] = useState(false);
	const [displayBasic, setDisplayBasic] = useState(false);
	const [toggleDeductionNumber, setToggleDeductionNumber] = useState(false)
	const [checked, setChecked] = useState(true);
	const [openNotification, setOpenNotification] = useState(false);
	const [closeErrorDialog, setCloseErrorDialog] = useState(false)
	const [selectedSegmentValue, setSelectedSegmentValue] = useState(null);
	const [disableButton, setDisableButton] = useState(false)
	const [deductionError, setDeductionError] = useState(null);
	const [selectedMultiTag, setSelectedMultiTag] = useState(null)
	const [selectedBusinessCustomer, setSelectedBusinessCustomer] = useState(null)
	const [customerSearchState, setCustomerSearchState] = useState(EMPTY_CUSTOMER_SEARCH_STATE)
	const selectedBusinessCustomerRef = useRef(null)
	selectedBusinessCustomerRef.current = selectedBusinessCustomer
	const [ambiguousCandidates, setAmbiguousCandidates] = useState([])
	const [selectedAmbiguousCustomerId, setSelectedAmbiguousCustomerId] = useState(null)
	const [chooseCustomerVisible, setChooseCustomerVisible] = useState(false)

	const [state, setState] = useState({
		selectedNodeKey: "",
		inviteData: {},
		checking: false,
		checkingExclusive: false,
		success: false,
		requesting: false,
		input: "",
		visible: false,
		hide: true,
		defMembership: null,
		confirmVisible: false,
		desireVisible: false,
		selectOptions: [],
		sort: 'requestedOn,desc',
		size: 10,
		generating: false,
		plan_tier: " ",
		newData_group: null,
		exclusivity: null,
		key: 0 - 1,
		exists: false,
		existVisible: false,
		phoneNo: ""
	});
	const paymentSaved = hasCurrentProviderCredentials({
		credentials,
		paymentCredentials,
		provider: business?.pmtProvider,
	});

	useEffect(() => {
		if (!business) {
			getBusiness(defMembership?.business?.id)
		}
		if (defMembership?.business?.id) {
			getMerchantAgreements(defMembership.business.id, business?.pmtProvider || defMembership.business.pmtProvider)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [business])

	useEffect(() => {
		let loading = fetchingVerifStatus || fetchingMerchantAgreements;
		setState((state) => { return { ...state, fetchingVerifRecord: loading }; });
		if (business) { setState((state) => ({ ...state, business: business })); }
		if (verificationStatus) { setState((state) => { return { ...state, verifStatus: verificationStatus }; }) }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [fetchingVerifStatus, fetchingMerchantAgreements, business, verificationStatus]);

	useEffect(() => {
		const nonArchivedGroups = planGroupsGraphedActive?.groups?.map((group) => {
			const nonArchivedPlans = group.plans.filter((plan) => !plan.status.includes("ARCHIVED"));
			return {
				...group,
				plans: nonArchivedPlans,
			};
		})

		if (nonArchivedGroups) {
			let planGroupAssigned = [];
			nonArchivedGroups.map((item, ind) => {
				const {
					group: { id },
					group,
					plans,
				} = item;

				planGroupAssigned.push({
					key: id,
					label: group.name,
					selectable: false,
					data: group,
					children:
						plans === null
							? []
							: plans.map((item, idx) => ({
								key: `${ind}-${idx}`,
								label: item.name,
								data: item,
							})),
				});
				setState((prev) => {
					return {
						...prev,
						selectOptions: planGroupAssigned
					}
				})
				return null;
			});
		}
	}, [planGroupsGraphedActive])

	useEffect(() => {
		if (state.checking && !fetchingExclusivity && exclusivity) {
			if (exclusivity.failed) {
				if (exclusivity.desired.id === exclusivity.existing.id) {
					setDisplayBasic(true)
					setState({ ...state, checking: false, exclusivity, })
				}
				else {
					setState({ ...state, checking: false, exclusivity, desireVisible: true })
				}
			}
		}
		if (state.checking && !fetchingExclusivity && exclusivity) {
			if (!exclusivity.failed) {
				setState({ ...state, checking: false, confirmVisible: true, success: false, requesting: true, generating: true })
			}
		}
		if (state.checking && !fetchingExclusivity && errorExclusivity) {
			showError()
		}
		if (sending && !generating && error) {
			const candidates = getAmbiguousBusinessCustomerCandidates(error);
			if (candidates.length > 0) {
				setAmbiguousCandidates(candidates);
				setSelectedAmbiguousCustomerId((currentId) => (
					candidates.some((candidate) => String(candidate.id) === String(currentId))
						? currentId
						: candidates[0].id
				));
				setChooseCustomerVisible(true);
				setSending(false);
				setState((prev) => ({ ...prev, confirmVisible: false }));
			} else if (error.message === t("invitation.already_sub-error-message")) {
				resetAmbiguousCustomerChoice();
				setState((state) => ({ ...state, existVisible: true }))
				resetForm()
				setCloseErrorDialog(true)
			} else {
				resetAmbiguousCustomerChoice();
				showError(t("invitation.invitation_error"))
				setSending(false)
			}
		}
		if ((sending && !generating && phoneVerification) || (makingBulkInvite && !bulkInviteSuccess)) {
			resetAmbiguousCustomerChoice();
			showSuccess()
			setSending(false)
		}

		if (initialTier) {
			Object.assign(initialTier, { label: initialTier.data.name, key: `${0}-${0}` })
			setState((state) => ({ ...state, selectedNodeKey: initialTier }))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state.requesting, sending, generating, error, state.checking, exclusivity, initialTier,
	state.confirmVisible, phoneVerification, state.generating, errorExclusivity, fetchingExclusivity, makingBulkInvite, bulkInviteSuccess])

	useEffect(() => {
		if (phoneNo) {
			const looksLocal = phoneNo.startsWith('+0') || !/^\+/.test(phoneNo.trim());
			const countryHint = looksLocal ? defMembership?.business?.country?.code : undefined;
			const dialHint = looksLocal ? defMembership?.business?.country?.phoneCode : undefined;
			const normalizedPhone = normalizePhoneNumber(phoneNo, dialHint, countryHint);
			formik.setFieldValue("number", normalizedPhone || phoneNo);
		}
	},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[phoneNo])

	const showSuccess = () => {
		const summary = t("success");

		const detail = !fromSubscriberImport
			? t("invitation.success_detail")
			: t("invitation.bulk_success_detail");

		setDisableButton(true)
		toast.current.show({
			severity: 'success',
			summary,
			detail,
			life: 4000,
			id: 5
		});
	};

	const showError = (data) => {
		toast.current.show({ severity: 'error', summary: t("failed"), detail: data, sticky: true, id: 2 });
	}

	const closeDialog = () => {
		setCloseErrorDialog(false)
		setSending(false)
	}

	const resetAmbiguousCustomerChoice = () => {
		setChooseCustomerVisible(false)
		setAmbiguousCandidates([])
		setSelectedAmbiguousCustomerId(null)
	}

	const resetForm = () => {
		formik.resetForm();
		setState((state) => { return { ...state, checking: false, requesting: false, selectedNodeKey: null, businessCustomerName: null } })
		setChecked(true)
		setSelectedBusinessCustomer(null)
		setCustomerSearchState(EMPTY_CUSTOMER_SEARCH_STATE)
		resetAmbiguousCustomerChoice()
	}

	const acceptInvite = () => {
		toogleInviteSubscriber()
		generateCode(state.inviteData);
		setSending(true)
		setState((state) => ({ ...state, generating: true, success: false, requesting: false, }));
	}

	const hideAmbiguousCustomerChoice = () => {
		if (generating) return;
		resetAmbiguousCustomerChoice();
		setSending(false);
	}

	const resubmitInviteWithCustomer = () => {
		const candidate = ambiguousCandidates.find(
			(item) => String(item.id) === String(selectedAmbiguousCustomerId)
		);
		if (!candidate?.id) return;

		const inviteData = {
			...(state.inviteData || {}),
			businessCustomer: { id: candidate.id },
		};
		setSelectedBusinessCustomer(candidate);
		selectedBusinessCustomerRef.current = candidate;
		setCustomerSearchState((prev) => ({
			...prev,
			query: candidate.name || "",
			selectedCustomerId: candidate.id,
		}));
		setSending(true);
		setState((prev) => ({
			...prev,
			inviteData,
			businessCustomerName: candidate.name || null,
			generating: true,
			confirmVisible: false,
		}));
		generateCode(inviteData);
	}
	const rejectInvite = () => {
		setState({ ...state, checking: false, success: false, requesting: false, confirmVisible: false, desireVisible: !state.desireVisible })
	}
	const hideInvite = () => {
		toogleConfirmInviteSubscriber()
		setState({ ...state, checking: false, success: false, requesting: false, confirmVisible: false })
	}
	const hideExclusivity = () => {
		setState({ ...state, checking: false, success: false, requesting: false, desireVisible: !state.desireVisible })
		setChecked(true)
	}

	const toogleInviteSubscriber = () => {
		if (fetchingVerifStatus || fetchingMerchantAgreements) {
			return <Loading />
		}
		else {
			if (business.verified && paymentSaved && !signingPending) {
				setState(state => { return { ...state, visible: !state.visible } })
			}
			else if (signingPending && business.verified && paymentSaved) {
				return openGoLiveOutstandingDialog();
			}
			else if (!business.verified) {
				if (verificationStatus && !fetchingVerifStatus) {
					return openGoLiveOutstandingDialog();
				}
				if (!verificationStatus && !fetchingVerifStatus) {
					switch (defMembership.role) {
						case "OWNER":
							return <OnboardingNotification visible={true} onHide={toggleSetOpenDialog} />
						default:
							toggleNotOwnerDialogue();
					}
				}
			}
			else if (business.verified && !paymentSaved) {
				return openGoLiveOutstandingDialog();
			}
		}
	}

	useEffect(() => {

		if (toggleVisible) {
			toogleInviteSubscriber()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [toggleVisible])

	const min = 2;

	const getBillingPeriodMax = () => {
		const billingPeriod = selectedData()?.data.billingPeriod || initialTier?.data?.billingPeriod
		switch (billingPeriod) {
			case 'DAILY': return 365;
			case 'DAILY_WITH_SATURDAYS': return 365;
			case 'DAILY_WITH_WEEKENDS': return 365;
			case 'WEEKLY': return 52;
			case 'BIWEEKLY': return 26;
			case 'MONTHLY': return 12;
			case 'QUARTERLY': return 12;
			case 'HALFYEARLY': return 6;
			case 'YEARLY': return 3;
			case 'ONCE': return 1;
			default: return 365;
		}
	};

	const amountCurrency = defMembership?.business?.currency;

	const formik = useFormik({
		initialValues: {
			plan: "",
			plan_tier: initialTier ? initialTier.data : "",
			number: phoneNo ? phoneNo : "",
			dialCode: defMembership?.business.country.phoneCode || "",
			countryCode: defMembership?.business.country.code || "gh",
			startDate: null,
			amount: null,
			target: null,
			deductions: undefined,
		},

		validate: (data) => {
			let errors = {};

			if (!initialTier && !data.plan_tier) {
				errors.plan_tier = <span className="inv_deduction_errors">{t("invitation.plan_error")}</span>
			}
			if ((policyType === "CUSTOM" && !data.amount)) {
				errors.amount = <span className="inv_deduction_errors">{t("invitation.amount_error")}</span>
			}
			if (policyType === "CUSTOM") {
				if (data.amount !== "" && data.amount !== undefined && data.amount !== null) {
					if (data.amount < 1 || data.amount > 10000) {
						errors.amount = (
							<Trans i18nKey="invitation.subscription_amount_range"
								values={{
									currency: amountCurrency,
									minAmount: t("invitation.min_amount"),
									maxAmount: t("invitation.max_amount")
								}}
								components={{
									1: <span className="inv_deduction_errors"></span>,
									2: <span className="inv_deduction_errors"></span>,
									3: <span className="inv_deduction_errors"></span>,
									4: <span className="inv_deduction_errors"></span>,
									5: <span className="inv_deduction_errors"></span>,
									6: <span className="inv_deduction_errors"></span>
								}}>
							</Trans>
						);
					}
				}
			}
			if (policyType === "TARGET" && !data.target) {
				errors.target = <span className="inv_deduction_errors">{t("invitation.target_amount_error")}</span>
			}
			if (policyType === "TARGET" && data.target === 0) {
				errors.target = <span className="inv_deduction_errors">{t("invitation.target_range_error")}</span>
			}
			if (policyType === "TARGET" && data.target && data.target < 100) {
				errors.target = <span className="inv_deduction_errors">{t("invitation.target_range_error")}</span>
			}
			if (policyType === "TARGET" && data.target && data.target > 50000) {
				errors.target = <span className="inv_deduction_errors">{t("invitation.target_range_error")}</span>
			}
			if (!checked && !data.startDate) {
				errors.startDate = <span className="inv_deduction_errors">{t("invitation.date_error")}</span>
			}
			if (!data.number || data.number.trim() === "") {
				errors.number = <span className="inv_deduction_errors">{t("invitation.number_error")}</span>
			} else {
				const invalidPrefix = getInvalidMobilePrefix(data.number, data.dialCode, data.countryCode);
				if (invalidPrefix) {
					errors.number = <span className="inv_deduction_errors">{t("invitation.invalid_mobile_prefix", invalidPrefix)}</span>
				} else if (!isValidInternationalPhoneNumber(data.number, data.dialCode, data.countryCode)) {
					errors.number = <span className="inv_deduction_errors">{t("invitation.invalid_number")}</span>
				}
			}
			if (toggleDeductionNumber === true && data.deductions === null) {
				errors.deductions = defMembership.business.purpose === "SERVICES" ?
					<span className="inv_deduction_errors">{t("invitation.deductions_placeholder_payments")}</span> :
					<span className="inv_deduction_errors">{t("invitation.deductions_placeholder_donations")}</span>
			}
			if (toggleDeductionNumber === true && data.deductions <= 0) {
				errors.deductions = <span className="inv_deduction_errors">{t("invitation.enter_positive_deductionNumber")}</span>
			}
			if (toggleDeductionNumber === true && data.deductions < min) {
				errors.deductions = defMembership.business.purpose === "SERVICES" ?
					<span className="inv_deduction_errors">{t("products.deduction_error_payments_min")}</span> :
					<span className="inv_deduction_errors" >{t("products.deduction_error_donations_min")}</span>
			}
			if (toggleDeductionNumber === true && !data.deductions) {
				errors.deductions = defMembership.business.purpose === "SERVICES" ?
					<span className="inv_deduction_errors">{t("invitation.deductionNumber_error_payments")}</span> :
					<span className="inv_deduction_errors">{t("invitation.deductionNumber_error_donations")}</span>
			}
			if (toggleDeductionNumber === true && data.deductions > getBillingPeriodMax()) {
				errors.deductions = defMembership.business.purpose === "SERVICES" ?
					<span className="inv_deduction_errors">{t("products.deduction_error_payments_max", { max })}</span> :
					<span className="inv_deduction_errors">{t("products.deduction_error_donations_max", { max })}</span>
			}

			return errors;
		},

		onSubmit: (data) => {
			const normalizedPhoneNumber = normalizePhoneNumber(phoneNo || data.number, data.dialCode, data.countryCode);

			if (!normalizedPhoneNumber || !isValidInternationalPhoneNumber(normalizedPhoneNumber)) {
				const invalidPrefix = getInvalidMobilePrefix(phoneNo || data.number, data.dialCode, data.countryCode);
				formik.setFieldTouched("number", true);
				formik.setFieldError(
					"number",
					invalidPrefix
						? t("invitation.invalid_mobile_prefix", invalidPrefix)
						: t("invitation.invalid_number")
				);
				return;
			}

			const id = initialTier ? initialTier.data.id : data.plan_tier.id
			const name = initialTier ? initialTier.data.name : data.plan_tier.name
			const business = initialTier ? initialTier.data.business : data.plan_tier.business
			const groupId = initialTier ? initialTier.data.groupId : data.plan_tier.groupId
			const collectionMode = initialTier ? initialTier.data.collectionMode : data.plan_tier.collectionMode
			const deductions = initialTier ? initialTier.data.deductions : selectedData().data.deductions
			const requestedOn = new Date();
			const msisdn = buildMsisdn(normalizedPhoneNumber);                      // "+233203675721"
			const subscriberPhoneNo = toLocalPhoneNumber(normalizedPhoneNumber);     // "0203675721"
			const planObj = { id, name, business, groupId, collectionMode };
			const amount = (initialTier?.data?.policy === "FIXED" && initialTier?.data?.cost !== null) ? initialTier?.data?.cost : null;
			const target = (initialTier?.data?.policy !== "FIXED" && initialTier?.data?.cost !== null) ? initialTier?.data?.cost : null;

			const tagNames = selectedMultiTag?.flatMap(i => i.name);
			const tagNamesJoinWithSlash = tagNames?.join("/")

			const invitationBusinessCustomer = toInvitationBusinessCustomer(selectedBusinessCustomerRef.current);
			const inviteData = {
				plan: planObj,
				phoneNo: subscriberPhoneNo,
				msisdn: msisdn,
				requestedBy: defMembership,
				requestedOn: moment(requestedOn).format(),
				startDate: data.startDate ? moment(data.startDate).format("YYYY-MM-DD") : null,
				amount: data.amount ? data.amount : amount,
				target: data.target ? data.target : target,
				deductions: data.deductions ? Number(data.deductions) : deductions,
				segment: selectedSegmentValue,
				tags: tagNamesJoinWithSlash,
				...(invitationBusinessCustomer ? { businessCustomer: invitationBusinessCustomer } : {}),
			};

			checkExclusivity(inviteData?.plan.id, inviteData.msisdn);
			setState({
				...state, checking: true, checkExclusivity: true, success: false,
				requesting: false, inviteData, exclusivity: null, phoneNo: subscriberPhoneNo,
				businessCustomerName: selectedBusinessCustomerRef.current?.name || null,
			});
		},
	});

	const applyCustomerPhone = (customerPhone) => {
		if (!customerPhone) return;
		const looksLocal = String(customerPhone).startsWith('+0') || !/^\+/.test(String(customerPhone).trim());
		const countryHint = looksLocal ? defMembership?.business?.country?.code : undefined;
		const dialHint = looksLocal ? defMembership?.business?.country?.phoneCode : undefined;
		const normalizedPhone = normalizePhoneNumber(customerPhone, dialHint, countryHint);
		formik.setFieldValue("number", normalizedPhone || customerPhone);
	};

	const handleCustomerSelect = (customer) => {
		if (customer) {
			setSelectedBusinessCustomer(customer);
			if (customer.phoneNo) {
				applyCustomerPhone(customer.phoneNo);
			}
			return;
		}

		const fallbackCustomer = businessCustomer || selectedSubscriberSegment || null;
		setSelectedBusinessCustomer(fallbackCustomer);
		if (fallbackCustomer) {
			setCustomerSearchState((prev) => ({
				...prev,
				query: fallbackCustomer.name || "",
				selectedCustomerId: fallbackCustomer.id || null,
			}));
		}
	};

	useEffect(() => {
		if (!state.visible) return;
		const customer = businessCustomer || selectedSubscriberSegment || null;
		setSelectedBusinessCustomer(customer);
		setCustomerSearchState({
			...EMPTY_CUSTOMER_SEARCH_STATE,
			query: customer?.name || "",
			selectedCustomerId: customer?.id || null,
		});
		if (customer?.phoneNo && !phoneNo) {
			applyCustomerPhone(customer.phoneNo);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state.visible]);

	const toogleConfirmInviteSubscriber = () => {
		setState(state => { return { ...state, confirmVisible: !state.confirmVisible } })
	}

	const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

	const getFormErrorMessage = (name) => {
		return (
			isFormFieldValid(name) && (
				<span className="p-error invitation_errors">{formik.errors[name]}</span>
			)
		);
	};

	const selectedData = (selectedNodeKey = state.selectedNodeKey) => {
		if (typeof selectedNodeKey === "string" && selectedNodeKey.includes("-")) {
			let selectedIndex = selectedNodeKey.split("-");
			let sampleData = state.selectOptions[parseInt(selectedIndex[0])]?.children?.[parseInt(selectedIndex[1])];
			return sampleData ?? null;
		}
		return null;
	};

	const planTierSelect = (e) => {
		formik.setFieldValue("plan_tier", selectedData(e.value)?.data);
		setState((state) => {
			return { ...state, selectedNodeKey: e.value }
		})
	}

	const foreverTxt = t("forever");
	const onceTxt = t("product.one");
	const today = new Date();
	const invalidDates = [today];
	const policyType = initialTier ? initialTier?.data.policy : selectedData()?.data.policy
	const billingType = initialTier ? initialTier?.data.billingPeriod : selectedData()?.data.billingPeriod

	const deductions = () => {
		let result;
		if (!initialTier && !selectedData()?.data) {
			result = ""
		}
		else if (initialTier) {
			if (initialTier?.data.deductions) {
				result = initialTier?.data.deductions
			}
			else {
				billingType === "ONCE" ? result = onceTxt :
					result = foreverTxt
			}
		}
		else if (!initialTier && selectedData().data) {
			if (selectedData().data.deductions) {
				result = selectedData().data.deductions
			}
			else {
				billingType === "ONCE" ? result = onceTxt :
					result = foreverTxt
			}
		}
		return result
	}

	//Toggle not Owner dialogue visibility
  const toggleGoLiveOutstandingDialogue = () => { setState((state) => { return { ...state, goLiveOutstandingVisible: !state.goLiveOutstandingVisible }; }); };
	const openGoLiveOutstandingDialog = () => {
		toggleGoLiveOutstandingDialogue();
	};

	//Toggle not Owner dialogue visibility
	const toggleNotOwnerDialogue = () => { setState((state) => { return { ...state, notOwnerVisible: !state.notOwnerVisible }; }); };

	const toggleNotSavedDialogue = () => { setState((state) => { return { ...state, notSavedVisible: !state.notSavedVisible } }) }

	const renderVerifFooter = (component) => {
		return (
			<div>
				<Button
					label={t("common.ok")}
					icon="pi pi-check"
					autoFocus
					style={{ backgroundColor: "#d0021b" }}
					onClick={() => { toggleNotOwnerDialogue(); handleHide() }}
				/>
			</div>
		);
	};

	const notSavedFooter = () => {
		return (
			<div>
				<Button style={{ backgroundColor: "#d0021b" }} label={t("common.ok")} icon="pi pi-check" autoFocus
					onClick={() => { toggleNotSavedDialogue(); onHide() }}
				/>
			</div>
		);
	}

	const renderFooter = () => {
		return (
			<div>
				<Button label={t("invitation.close")} icon="pi pi-times"
					onClick={() => setDisplayBasic(false)} autoFocus />
			</div>
		);
	}

	const handleHide = () => {
		onHide()
	}

	const toggleSetOpenDialog = () => {
		setOpenNotification(!openNotification);
	};

	const formatEqualAmount = () => {
		if (!toggleDeductionNumber && initialTier) {
			return formik.values.target / initialTier?.data.deductions
		}
		else if (!toggleDeductionNumber && formik.values.plan_tier) {
			return formik.values.target / formik.values.plan_tier?.deductions
		}
		else if (toggleDeductionNumber && formik.values.deductions) {
			return formik.values.target / formik.values.deductions
		}
	};

	const equalAmount = formatEqualAmount();

	const handleBulkInvite = async () => {
		const { values, validateForm, setTouched } = formik;

		const errors = await validateForm();
		delete errors.number;

		setTouched({
			plan_tier: true,
			startDate: true,
			amount: true,
			target: true,
			deductions: true,
		});

		if (Object.keys(errors).length > 0) {
			return;
		}

		const { plan_tier, deductions, startDate, amount, target } = values;

		const bulkInviteData = {
			planId: plan_tier.id,
			targetListId: csvFileData?.id,
			deductions: deductions || "",
			startDate: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
			amount: amount || null,
			target: target || null
		};
		sendBulkInvite(defMembership.business.id, bulkInviteData);
	};

	const billingPeriod = initialTier ? t(`invitation.${initialTier?.data?.billingPeriod?.toLowerCase()}`) :
		t(`invitation.${formik.values.plan_tier.billingPeriod?.toLowerCase()}`);
	const planDeductions = toggleDeductionNumber ? formik.values.deductions : initialTier ? initialTier?.data?.deductions : formik.values.plan_tier.deductions;
	const planPurpose = defMembership?.business.purpose === "DONATION" ? t("invitation.donations") : t("invitation.payments");

	const { currencyFormat, currencySymbol } = useCurrencyConstants();
	const targetAmount = formik.values.target;

	const displayedCurrencySymbol = toggleDeductionNumber && formik.values.deductions === "" ? "" : currencySymbol;

	const toggleDeductions = toggleDeductionNumber && formik.values?.deductions === "";
	// const businessPurpose = defMembership?.business.purpose;

	const [originalDeductions, setOriginalDeductions] = useState(formik.values.deductions);


	// eslint-disable-next-line no-unused-vars
	const handleSwitchToggle = () => {
		if (!toggleDeductionNumber) {
			setOriginalDeductions(formik.values.deductions);
			formik.setFieldValue("deductions", "");
		} else {
			formik.setFieldValue("deductions", originalDeductions);
		}
		setToggleDeductionNumber((prev) => !prev);
	};

	const max = getBillingPeriodMax();

	return (
		<>
			<GoLiveOutstandingDialog
				visible={state.goLiveOutstandingVisible}
				onHide={toggleGoLiveOutstandingDialogue}
			/>
			<Dialog
				header={t("idoc.not_owner_header")}
				visible={state.notOwnerVisible}
				style={{ width: "360px" }}
				onHide={() => { toggleNotOwnerDialogue(); onHide() }}
				footer={renderVerifFooter("not_owner")}
			>
				<p>{t("idoc.not_owner_text")}</p>
				<SigningPendingNotice business={business} />
			</Dialog>
			<Dialog
				header={t("idoc.not_owner_header")} style={{ width: "360px" }} visible={state.notSavedVisible}
				onHide={() => { toggleNotSavedDialogue(); onHide() }} footer={notSavedFooter}
			>
				<p>{t("idoc.id_verif_pending_text")}</p>
				<SigningPendingNotice business={business} />
			</Dialog>
			<Dialog
				header={t("idoc.not_owner_header")}
				visible={state.notOwnerVisible}
				style={{ width: "360px" }}
				onHide={toggleNotOwnerDialogue}
				footer={renderVerifFooter("not_owner")}
			>
				<p>{t("idoc.not_owner_text")}</p>
				<SigningPendingNotice business={business} />
			</Dialog>
			<Dialog
				header={t("idoc.not_owner_header")} style={{ width: "360px" }} visible={state.notSavedVisible}
				onHide={() => { toggleNotSavedDialogue(); onHide() }} footer={notSavedFooter}
			>
				<div className="idoc-div" >
					<span className="not_saved" >{t("idoc.not_saved_viewer1")}</span>
					<p className="not_saved2">{t("idoc.not_saved_viewer2")}</p>
					<SigningPendingNotice business={business} />
				</div>
			</Dialog>
			{(state.inviteData && state.confirmVisible) &&
				<ConfirmDialog visible={state.confirmVisible} onHide={hideInvite} className="confirm_close_btn" id="tier_dialog"
					message={<div style={{ marginTop: "0.6rem" }}>
						<span className="confirm_invite_detail detail">{t("invitation.confirm_invite_detail")}</span>&nbsp;
						{state.businessCustomerName ? (
							<span className="customerName_invite">{state.businessCustomerName}</span>
						) : null}
						{state.businessCustomerName ? <>&nbsp;</> : null}
						<span className="phoneNo_invite">{removePlusFromNum(state.inviteData.msisdn)}</span>&nbsp;
						<span className="confirm_invite_detail">{t("invitation.subscribe_text")}</span>&nbsp;
						<span className="planName_invite">{state.inviteData.plan.name}</span>&nbsp;
						<AutoBillingBadge collectionMode={state.inviteData.plan.collectionMode} />&nbsp;
						<span className="confirm_invite_detail">{"?"}</span>
					</div>}
					header={t("invitation.confirm_header")} accept={acceptInvite} reject={rejectInvite} />
			}

			{
				<ConfirmDialog visible={closeErrorDialog} onHide={() => closeDialog()} className="confirm_close_btn" id="tier_dialog"
					message={<div style={{ marginTop: "0.6rem" }}>
						{t("invitation.already_subscribed")}
					</div>}
					header={t("invitation.warning")}
					footer={<Button onClick={() => closeDialog()} className="p-mt-2" id="close-confirm-dialog"><i className="pi pi-times m-1"></i>{t("invitation.close")}</Button>}
				/>
			}

			<AmbiguousCustomerDialog
				visible={chooseCustomerVisible}
				candidates={ambiguousCandidates}
				selectedId={selectedAmbiguousCustomerId}
				onSelect={setSelectedAmbiguousCustomerId}
				onCancel={hideAmbiguousCustomerChoice}
				onContinue={resubmitInviteWithCustomer}
				loading={generating}
			/>

			{(state.exclusivity && state.desireVisible) &&
				<Dialog id="tier_dialog" className="tier_dialog" style={{ width: "360px" }} visible={state.desireVisible} header={<div>
					<span className="dialog_header" >{t("invitation.migrate_dialog_header")}{"?"}</span>
				</div>} onHide={() => hideExclusivity()}
					footer={<div style={{ marginBottom: "1rem" }}>
						<Button icon="pi pi-times" onClick={() => hideExclusivity()} label={t("invitation.cancel_move")} className="p-button-text hideBtn" />
						<Button onClick={() => acceptInvite()} loading={generating} label={t("invitation.migrate_subs_btn")} className="acceptBtn" />
					</div >} modal breakpoints={{ '960px': '75vw', '640px': '100vw' }} >
					<div className="first_blue_background">
						<span className="first_span ml-2">{t("invitation.first_title")}</span>
					</div>

					<div className="long_description">
						<p className="description_p">
							<Trans
								i18nKey="invitation.hint_text"
								values={{ num: state.phoneNo || phoneNo, prod: state?.exclusivity?.existing?.group?.name }}
								components={{ 1: <span className="span_1 ml-0" style={{ color: "#D0021B" }} />, 2: <span className="span_1 ml-0" style={{ color: "#805b36" }} /> }}
							/>
						</p>
					</div>

					<div><p className="current_tier_header">{t("invitation.current_subscription_text")}</p></div>
					<div className="blue_background">
						<p className="m-0">{policyDisplay(state.exclusivity?.existing)}</p>
						<p className="existing_name m-0">{state.exclusivity?.existing.name}</p>
						<p className="plan-desc m-0">{state.exclusivity?.existing.description}</p>
						<p className="amounts-text m-0">{amountDisplayPerPolicy(defMembership.business.currency, state.exclusivity?.existing)}</p>
						<p className="amounts m-0">{formatBillingPeriodText(state.exclusivity?.existing.billingPeriod.toUpperCase())}</p>
					</div>
					<p className="p_hr_tag" />

					<div><p className="new_tier_header">{t("invitation.new_subscription_text")}</p></div>
					<div className="green_background">
						<p className="m-0">{policyDisplay(state.exclusivity?.desired)}</p>
						<p className="existing_name m-0">{state.exclusivity?.desired.name}</p>
						<p className="plan-desc m-0">{state.exclusivity?.desired.description}</p>
						<p className="amounts-text m-0">{amountDisplayPerPolicy(defMembership.business.currency, state.exclusivity?.desired)}</p>
						<p className="amounts m-0">{formatBillingPeriodText(state.exclusivity?.desired.billingPeriod.toUpperCase())}</p>
					</div>
				</Dialog>}

			{(state.exclusivity && displayBasic) && <Dialog header={t("invitation.warning")} visible={displayBasic}
				id="tier_dialog" style={{ width: "360px" }} footer={renderFooter} onHide={() => setDisplayBasic(false)}>
				<p>{t("invitation.already_subscribed")} {state.exclusivity.desired.name}.</p>
			</Dialog>}

			<Toast ref={toastConfirm} onRemove={(message) => {
				if (message.severity === 'success') {
					resetForm()
				}
			}} />

			<Toast ref={toast} onRemove={(message) => {
				if (message.severity === 'success') {
					onHide()
					getSelfSignups(defMembership.business.id, { sort: state.sort, size: state.size, });
					setState({ ...state, send: false });
					setChecked(false);
					setSending(false);
					setDisableButton(false);
					setState((state) => ({ ...state, desireVisible: false, visible: false }));
					setToggleDeductionNumber(false);
					getBusiness(defMembership.business.id)
					fetchAllImportedCustomers(0);
					resetForm();
					callbackFunctions();
				}
			}} />

			<div className="p-grid p-nogutter text-justify flex justify-between">
				<Dialog
					header={header ? header : t("invitation.invite")}
					visible={state.visible}
					className="tier_dialog"
					id="tier_dialog"
					onHide={() => {
						handleHide();
						setToggleDeductionNumber(false);
						formik.setFieldValue("number", "");
						setSelectedMultiTag(null);
						setSelectedBusinessCustomer(null);
						setCustomerSearchState(EMPTY_CUSTOMER_SEARCH_STATE);
						setState(() => ({ ...state, visible: false }));
						resetForm();
						setSelectedSegmentValue(null)
					}}>
					{(!planGroupsGraphedActive || !business || !defMembership) ? <Loading /> :
						<>
							<div style={{ padding: "1.5rem" }}>
								<div className="p-fluid">
									<PlanTreeSelect {...{ state, initialTier, planTierSelect, isFormFieldValid, csvFileData, selectedData, getFormErrorMessage, fromSubscriberImport }} />
								</div>
								<form onSubmit={formik.handleSubmit} className={`p - fluid flex flex - column ${!fromSubscriberImport ? "mt-3" : ""}`}>
									{!fromSubscriberImport && (
										<div className="invite-customer-search">
											<div className="title flex">
												<p className="labels">{t("business_customers.subscriber_name")}</p>
											</div>
											<GlobalSearch
												state={customerSearchState}
												setState={setCustomerSearchState}
												defMembership={defMembership}
												globalQuery={false}
												skipDetailsFetch
												compact
												placeholder={t("invitation.search_placeholder")}
												onCustomerSelect={handleCustomerSelect}
												globalBorderWidth={{ width: "100%", border: "none" }}
											/>
										</div>
									)}
									<PhoneNumberInputText
										defaultCountry={defMembership.business.country.code.toLowerCase() || 'gh'}
										{...{ fromSubscriberImport, getFormErrorMessage, formik, phoneNo, isFormFieldValid }}
									/>

									<AmountInputNumber {...{ policyType, formik, getFormErrorMessage, defMembership }} />
									<br />

									<div style={{ marginBottom: "1.3rem" }}>
										<StartDateCalender {...{ formik, business, checked, setChecked, getFormErrorMessage, isFormFieldValid, today, invalidDates }} />
									</div>

									<div>
										<DeductionsInput {...{
											formik, originalDeductions, toggleDeductionNumber, selectedData, setToggleDeductionNumber, setOriginalDeductions,
											deductionError, setDeductionError, error, getBillingPeriodMax, defMembership, min, max, initialTier, getFormErrorMessage,
											deductions, isFormFieldValid
										}} />

										{/* These might be needed later */}
										{/* <SegmentDropdown {...{ selectedSegmentValue, setSelectedSegmentValue, selectedSubscriberSegment }} />
										<TagsMultiselect {...{ setSelectedMultiTag, selectedMultiTag }} /> */}

									</div>

									{(policyType === "TARGET") &&
										(formik.values.target) &&
										(!formik.errors.target) //Hides the summary part when target has an error
										&& (initialTier ? !initialTier?.data?.fixedTarget
											: (formik.values.target) && !formik.values.plan_tier.fixedTarget) ?
										(<div>
											<hr className="first_hr_summary" />
											<Trans
												i18nKey="invitation.different_summary"
												values={{
													billingPeriod: billingPeriod,
													deductions: planDeductions,
													cost: FormatCurrency({
														amount: targetAmount,
														currencySymbol: displayedCurrencySymbol,
														currencyFormat: currencyFormat,
														as: "string"
													}),
													purpose: planPurpose
												}}
												components={{
													1: <span className="first_sum_txt" />,
													2: <span className="second_sum_txt" />,
													3: <br />,
													4: <span className="first_sum_txt" />,
													5: <span className="amount_sum_txt" />,
													6: <span className="billingPeriod_sum_txt" />,
													7: <br />,
													8: <span className="first_sum_txt" />,
													9: <span className="deduction_sum_txt" />,
													10: <span className="deduction_sum_txt" />
												}}>
											</Trans>
											<hr className="hr_summary" />
										</div>) : null
									}

									{(policyType === "TARGET") &&
										(formik.values.target) &&
										(!formik.errors.target) &&   //Hides the summary part when target has an error
										(initialTier
											? initialTier?.data?.fixedTarget
											: (formik.values.plan_tier.fixedTarget && formik.values.target)) ? (<div>
												{(toggleDeductions) ? <span className="first_sum_display" /> :
													<hr className="first_hr_summary" />}
												<Trans
													i18nKey="invitation.equal_summary_info"
													values={{
														planBillingPeriod: toggleDeductionNumber && formik.values.deductions === "" ? "" : billingPeriod,
														planDeductions: toggleDeductionNumber && formik.values.deductions === "" ? "" : planDeductions,
														cost: FormatCurrency({
															amount: targetAmount,
															currencySymbol: displayedCurrencySymbol,
															currencyFormat: currencyFormat,
															as: "string"
														}),
														equalAmount:
															FormatCurrency({
																amount: equalAmount,
																currencySymbol: displayedCurrencySymbol,
																currencyFormat: currencyFormat,
																as: "string"
															}),
														purpose: toggleDeductionNumber && formik.values.deductions === "" ? "" : planPurpose
													}}

													components={{
														1: (toggleDeductions) ? <span className="first_sum_display" /> : <span className="first_sum_txt" />,
														2: (toggleDeductions) ? <span className="first_sum_display" /> : <span className="second_sum_txt" />,
														3: <br />,
														4: (toggleDeductions) ? <span className="first_sum_display" /> : <span className="first_sum_txt" />,
														5: <span className="amount_sum_txt" />,
														6: <span className="billingPeriod_sum_txt" />,
														7: <br />,
														8: <span className="deduction_sum_txt" />,
														9: <span className="purpose_invt" />
													}}>
												</Trans>
												{(toggleDeductions) ? <span className="first_sum_display" /> :
													<hr className="hr_summary" />}
											</div>
									) : null}

									{fromSubscriberImport ?
										<Button
											className="p-mt-2"
											id="send_invite_btn"
											onClick={() => {
												handleBulkInvite()
											}}
											loading={makingBulkInvite}
											disabled={makingBulkInvite || disableButton}
										>{t("invitation.send_bulk_invite")}
										</Button>
										:
										<Button
											type="submit"
											icon="pi pi-send"
											label={t("invitation.send_invite")}
											loading={generating || fetchingExclusivity}
											disabled={
												state.requesting ||
												generating ||
												disableButton ||
												Boolean(formik.errors.target)
											}
											className="p-mt-2"
											id="send_invite_btn"
										/>
									}
								</form>
							</div>
						</>
					}
				</Dialog >
			</div >
		</>
	)
}

export default (InviteSubscriber);